import { enableProdMode } from '@angular/core';
import { loadGoogleMapsScript } from '@shared/scripts/google-maps-scripts';
import 'hammerjs';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Load Google Maps script dynamically before bootstrapping the Angular app
loadGoogleMapsScript().catch((error) => {
  console.error('Error loading Google Maps script:', error);
});
